export const timelineOptions = [
	{ label: "FY2025", value: "LastYear" },
	{ label: "YTD", value: "YTD" },
	{ label: "Running 12 Months", value: "running12Month" },
];

export const projectType = [
	{ label: "Project", value: "Project" },
	{ label: "Non-Project", value: "Non-Project" },
	{ label: "All", value: [] },
];
export const priority = [
	{ label: "Priority 1", value: 1 },
	{ label: "Priority 2", value: 2 },
	{ label: "All", value: 3 },
];

export const drillDownType = [
	{ label: "Supplier", value: "supplier" },
	{ label: "District", value: "district" },
	{ label: "All", value: "all" },
];

export const supplierDrillDownType = [
	{ label: "District", value: "district" },
	{ label: "Category", value: "l3" },
	{ label: "Supplier Benchmarking", value: "supplierBenchmarking" },
];

export const districtDrillDownType = [
	{ label: "Supplier", value: "supplier" },
	{ label: "Category", value: "l3" },
];

export const addressableSpend = [
	{ label: "Excluding NOF/LOTs", value: 0 },
	{ label: "Including NOF/LOTs ", value: 1 },
];

export const niaMaskStatus = [
	{ label: "Yes", value: 1 },
	{ label: "No", value: 0 },
];

export const SpendFlag = {
	Purchases: "Invoice Spend",
	Sales: "Sales",
};

export const spendType = [
	{ label: "Stock", value: "Stock" },
	{ label: "Non-Stock", value: "NonStock" },
	{ label: "All", value: "" },
];

export const topSupplierCount = [
	{ label: "All", value: null },
	{ label: "Top 10", value: 10 },
	{ label: "Top 15", value: 15 },
	{ label: "Top 20", value: 20 },
];

export const leakageTimelineOptions = [
    { label: "Pre Go Live v Post Go Live", value: "preGoLive" },
	{ label: "Last Year", value: "lastYear" },
	{ label: "Last Month", value: "last1Months" },
	{ label: "Last 3 Months", value: "last3Months" },
	{ label: "Last 6 Months", value: "last6Months" },
	{ label: "Last 12 Months", value: "last12Months" },
];

export const leakageTimelineOptions2 = [
	{ label: "Pre go live v post go live", value: "preGoLive" },
	{ label: "Last Month v Latest 4 weeks", value: "last1Months" },
	{ label: "Last  3 Months v Latest 4 weeks", value: "last3Months" },
	{ label: "Last  6 Months v Latest 4 weeks", value: "last6Months" },
	{ label: "Last  12 Months v Latest 4 weeks", value: "last12Months" },
];
